import React from 'react';

const PrivacyPolicy = () => {
    return (
        <>
            <div className='privacy_policy_inner'>
                <div className='container'>
                    <h3>Privacy Policy</h3>
                    <div style={{
                        maxWidth: '1024px',
                        margin: '0 auto',
                        padding: '40px 16px',
                        color: '#333',
                        fontSize: '14px',
                        lineHeight: '1.75'
                    }}>
                        <p style={{ marginBottom: '16px' }}>
                            This Privacy Policy outlines how <strong>NannyLine</strong> collects, uses, and protects user information. By using our platform, you agree to the practices described below.
                        </p>

                        <h5 style={{ fontWeight: '600', marginTop: '24px', marginBottom: '8px' }}>1. Data Collection and Usage</h5>
                        <p>
                            Our nanny app collects personal data such as name, contact information, and preferences to facilitate the matching process between caregivers and families.
                            This data is used solely for providing childcare services and enhancing user experience.
                        </p>

                        <h5 style={{ fontWeight: '600', marginTop: '24px', marginBottom: '8px' }}>2. Data Deletion Policy</h5>
                        <p>Users have the right to request the deletion of their personal data from our servers and databases.</p>
                        <ul style={{ paddingLeft: '20px', marginBottom: '16px', listStyleType: 'disc' }}>
                            <li>Upon receiving such requests, we will promptly and securely delete all relevant data, including contact information and messages.</li>
                            <li>Deleted data will be permanently removed from all storage systems in compliance with applicable data protection laws.</li>
                            <li>Users can initiate a deletion request via app settings or by contacting our support team.</li>
                        </ul>

                        <h5 style={{ fontWeight: '600', marginTop: '24px', marginBottom: '8px' }}>3. Data Pull Policy</h5>
                        <ul style={{ paddingLeft: '20px', marginBottom: '16px', listStyleType: 'disc' }}>
                            <li>We may periodically review and delete inactive accounts or outdated data to maintain data integrity.</li>
                            <li>Inactive accounts may be subject to deletion to ensure stored information is accurate and relevant.</li>
                            <li>Users will be notified before their data is deleted due to inactivity.</li>
                            <li>Strict security protocols are followed during data pull processes.</li>
                        </ul>

                        <h5 style={{ fontWeight: '600', marginTop: '24px', marginBottom: '8px' }}>4. User Consent</h5>
                        <ul style={{ paddingLeft: '20px', marginBottom: '16px', listStyleType: 'disc' }}>
                            <li>We obtain explicit consent before collecting, processing, or storing personal data.</li>
                            <li>Users can manage their privacy preferences in the app settings.</li>
                            <li>By using our app, users consent to the practices outlined in this policy.</li>
                        </ul>

                        <h5 style={{ fontWeight: '600', marginTop: '24px', marginBottom: '8px' }}>5. Security Measures</h5>
                        <ul style={{ paddingLeft: '20px', marginBottom: '16px', listStyleType: 'disc' }}>
                            <li>We use strong security measures to protect personal data from unauthorized access or disclosure.</li>
                            <li>Encryption, access controls, and regular audits are used to ensure data privacy.</li>
                        </ul>

                        <h5 style={{ fontWeight: '600', marginTop: '24px', marginBottom: '8px' }}>6. Data Retention</h5>
                        <ul style={{ paddingLeft: '20px', marginBottom: '16px', listStyleType: 'disc' }}>
                            <li>Personal data is retained only as long as necessary to fulfill the purposes stated in this policy or as required by law.</li>
                            <li>After the retention period, data will be securely deleted or anonymized.</li>
                        </ul>

                        <h5 style={{ fontWeight: '600', marginTop: '24px', marginBottom: '8px' }}>7. Transparency</h5>
                        <ul style={{ paddingLeft: '20px', marginBottom: '16px', listStyleType: 'disc' }}>
                            <li>Our data deletion and pull policies are explained transparently in this privacy policy.</li>
                            <li>Users are informed of their rights and can initiate data deletion procedures at any time.</li>
                            <li>Changes to this policy will be communicated via the app or email.</li>
                            <li>For concerns about privacy practices, users can contact our customer support team.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
